import { TextColors } from '@picsart/design-system/foundation/colors';

import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  {
    root: {
      color: TextColors.base,
      paddingBlock: Spacings.s56,
      textAlign: 'center',

      '@media screen and (max-width: 768px)': {
        paddingBlock: Spacings.s40,

        '& li:last-child': {
          paddingRight: Spacings.s12,
        },
      },
    },

    wrapper: {
      '@media screen and (max-width: 768px)': {
        paddingRight: Spacings.s0,
      },
    },

    title: {
      marginBottom: Spacings.s40,
    },

    container: {
      display: 'flex',
      justifyContent: 'center',
    },

    imgContainer: {
      display: 'flex',
      gap: Spacings.s24,
      listStyleType: 'none',
      overflowX: 'auto',

      '@media screen and (max-width: 768px)': {
        gap: 20,
      },
    },

    item: {
      display: 'flex',
      flexDirection: 'column',
      maxWidth: 370,

      '@media screen and (max-width: 768px)': {
        width: 275,
      },
    },

    img: {
      borderRadius: CornerRadius.r20,
      marginBottom: Spacings.s16,
    },
  },
  {
    name: 'image-with-text-list',
  },
);

export default useStyles;
